import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import DomesticSearchProxy from '../proxies/DomesticSearchProxy'

class DomesticSearchService extends ServiceBase {
  postDomesticSearch(params) {
    return this.getData(() => DomesticSearchProxy.postDomesticSearch(params))
  }

  postDomesticSearchCount(params) {
    return this.getData(() =>
      DomesticSearchProxy.postDomesticSearchCount(params),
    )
  }

  getDomesticSearchDetail(params) {
    return this.getData(() =>
      DomesticSearchProxy.getDomesticSearchDetail(params),
    )
  }
}

export default new DomesticSearchService()
